export * from 'agora-rtc-react'
import AgoraRTC, { IAgoraRTCClient, AgoraRTCProvider } from 'agora-rtc-react'
import React from 'react'

export type { IAgoraRTCRemoteUser } from 'agora-rtc-react'

export const rtcClient: IAgoraRTCClient = AgoraRTC.createClient({
  mode: 'rtc',
  codec: 'vp8'
})
AgoraRTC.setLogLevel(4)

export const AgoraProvider = ({ children }: { children: React.ReactNode }) => {
  return <AgoraRTCProvider client={rtcClient}>{children}</AgoraRTCProvider>
}
